import { defineStore } from 'pinia'

export const useLastOrdersStore = defineStore({
  id: "lastOrders",

  state: () => {
    return {
      lastList: [] as any[],
      isLoadLastList: false,
      checkOrdersTimerId: null as number | null,
    }
  },

  actions: {
    changeLoadLastList: function (val: boolean) {
      this.isLoadLastList = val;
    },
    setCheckOrdersTimerId: function (timerId: number | null) {
      this.checkOrdersTimerId = timerId;
    },
    startCheckLastOrders: async function () {
      console.log('state.checkOrdersTimerId: ', this.checkOrdersTimerId)
      if (this.checkOrdersTimerId !== null) return

      const orderSuccessHashCookie = useCookie('order_success_hash');
      if (!orderSuccessHashCookie.value) return;

      const timerId = window.setTimeout(async () => {
        await this.checkLastOrders();
      }, (10000));
      this.setCheckOrdersTimerId(timerId);
    },
    checkLastOrders: async function () {
      if (this.isLoadLastList) {
        return
      }

      const orderSuccessHashCookie = useCookie('order_success_hash');
      if (!orderSuccessHashCookie.value) {
        return
      }

      this.changeLoadLastList(true);

      const { $api, $i18n, $zarazTrack, $ym } = useNuxtApp() as any;

      const commerceOrders = await $api.agent.get(`/users/commerce-orders?hash=${orderSuccessHashCookie.value}`).then((res: any) => {
        return res._data || []
      }).catch(() => {
        return []
      });
      if (commerceOrders.length <= 0) {
        this.changeLoadLastList(false);
        return
      }

      const body = {
        order_ids: commerceOrders.map((t: any) => t.id)
      };
      const isSuccess = await $api.agent.post(`/users/commerce-orders-save?hash=${orderSuccessHashCookie.value}`, { body }).then(() => {
        return true
      }).catch(() => {
        return false
      });
      if (!isSuccess) {
        this.changeLoadLastList(false);
        return
      }
      if (commerceOrders && commerceOrders.length > 0) {
        commerceOrders.forEach((item: any) => {
          // Отправка цели в Яндекс.Метрику для Yapaycard
          if (item.payment_method_name === 'Yapaycard' && typeof $ym === 'function') {
            $ym('reachGoal', 'payment_yapaycard_final');
          }
          // Отправка цели в Яндекс.Метрику для Yapaysplit
          if (item.payment_method_name === 'Yapaysplit' && typeof $ym === 'function') {
            $ym('reachGoal', 'payment_yapaysplit_final');
          }
        })

        // Очищаем куку после отправки целей
        orderSuccessHashCookie.value = null;
      }

      this.changeLoadLastList(false);
    }
  }
});
